import React, { lazy, Suspense } from 'react';
import './App.css';
import './styles/sendhapy.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';

import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TrackingSection from './components/TrackingSection';
import PricingSection from './components/PricingSection';
import BenefitsSection from './components/BenefitsSection';
import CasilleroSection from './components/CasilleroSection';
import PermisosSection from './components/PermisosSection';
import TestimonialsSection from './components/TestimonialsSection';
import CredentialsSection from './components/CredentialsSection';
import AboutSection from './components/AboutSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
const AdminCasilleros = lazy(() => import('./components/AdminCasilleros'));
const AdminPrealertas = lazy(() => import('./components/AdminPrealertas'));
const AdminFacturas = lazy(() => import('./components/AdminFacturas'));
import ClienteAuth from './pages/ClienteAuth';
import ClienteDashboard from './pages/ClienteDashboard';
import { RecuperarPassword, RestablecerPassword } from './pages/RecuperarPassword';
const AdminNuevosClientes = lazy(() => import('./pages/admin/AdminNuevosClientes'));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminResumen = lazy(() => import('./pages/admin/AdminResumen'));
const AdminRevision = lazy(() => import('./pages/admin/AdminRevision'));
const AdminClientes = lazy(() => import('./pages/admin/AdminClientes'));
const AdminCumpleanos = lazy(() => import('./pages/admin/AdminCumpleanos'));
const AdminEntregas = lazy(() => import('./pages/admin/AdminEntregas'));
const AdminPesos = lazy(() => import('./pages/admin/AdminPesos'));
const AdminConfig = lazy(() => import('./pages/admin/AdminConfig'));

const Home = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <TrackingSection />
      <PricingSection />
      <BenefitsSection />
      <CasilleroSection />
      <PermisosSection />
      <TestimonialsSection />
      <AboutSection />
      <CredentialsSection />
      <FAQSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<div className="p-10 text-gray-400">Cargando...</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminResumen />} />
            <Route path="revision" element={<AdminRevision />} />
            <Route path="clientes" element={<AdminClientes />} />
            <Route path="cumpleanos" element={<AdminCumpleanos />} />
            <Route path="entregas" element={<AdminEntregas />} />
            <Route path="pesos" element={<AdminPesos />} />
            <Route path="config" element={<AdminConfig />} />
            <Route path="nuevos" element={<AdminNuevosClientes />} />
            <Route path="casilleros" element={<AdminCasilleros />} />
            <Route path="prealertas" element={<AdminPrealertas />} />
            <Route path="facturas" element={<AdminFacturas />} />
          </Route>
          <Route path="/cliente" element={<ClienteAuth />} />
          <Route path="/mi-cuenta" element={<ClienteDashboard />} />
          <Route path="/recuperar" element={<RecuperarPassword />} />
          <Route path="/restablecer" element={<RestablecerPassword />} />
        </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
